// The ruleset flag folded into the one value an opening command takes.
//
// Resolved in the shell and handed down as a value, the shape `wave-delay`
// already takes and for its reason: `src/engine/rules/` and `src/engine/ai/` are barred from
// reading a flag, so what reaches an opening command is a plain object the
// flags chose — and from there it replays and hashes like any other setup.

import { useMemo } from "react";

import { DEFAULT_RULESET, isDefaultRuleset, type Ruleset } from "src/engine/rules/ruleset";
import { useFlag } from "./useFlag";

/**
 * The ruleset a fresh game should open on, or `undefined` for the default.
 *
 * **Undefined rather than the default spelled out**, so an opening command
 * outside every experiment carries no field at all and is byte-identical to
 * what this build sent before rulesets existed. Memoised on the answer,
 * because callers put it in effect dependency lists.
 */
export function useDefaultRuleset(): Ruleset | undefined {
  const spawnClock = useFlag("ruleset-spawn-clock");
  return useMemo(() => {
    const ruleset: Ruleset = { spawn: spawnClock ? "clock" : DEFAULT_RULESET.spawn };
    return isDefaultRuleset(ruleset) ? undefined : ruleset;
  }, [spawnClock]);
}
